import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { ThemeProvider } from "@/contexts/ThemeContext";

// Auto-reload when a lazy-loaded JS chunk is missing (happens after a new deploy
// when the browser has a stale bundle cached that references old chunk filenames).
window.addEventListener('error', (event) => {
  const isChunkError =
    event?.error?.name === 'ChunkLoadError' ||
    (typeof event?.message === 'string' && event.message.toLowerCase().includes('loading chunk'));
  if (isChunkError) {
    const reloadKey = '__chunk_reload__';
    if (!sessionStorage.getItem(reloadKey)) {
      sessionStorage.setItem(reloadKey, '1');
      window.location.reload();
    }
  }
});

// Patch ResizeObserver to suppress benign "loop completed" errors
// These occur with Radix UI dropdowns and are completely harmless
const RO = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends RO {
  constructor(callback) {
    super((entries, observer) => {
      // Use requestAnimationFrame to batch notifications and prevent loop errors
      window.requestAnimationFrame(() => {
        try {
          callback(entries, observer);
        } catch (e) {
          // Silently ignore resize observer errors
        }
      });
    });
  }
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>,
);
